import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getManageCertificates = (searchText, pageNumber, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.CERTIFICATE_MANAGEMENT.GET_MANAGE_CERTIFICATES(
      searchText,
      pageNumber,
      pageSize
    ),
    "",
    cancelToken
  );
};

export default getManageCertificates;
